import './App.css';
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Routes, Route } from "react-router-dom";
import PrivateRoute from './routes/PrivateRoute';

import Login from './pages/auth/Login';
import Otp from "./pages/auth/Otp";
import HomePage from "./components/home/Home";
import PageNotFound from "./components/layout/PageNotFound";
import AppLayout from './components/layout/AppLayout';
import RolePage from './pages/role/RolePage';
import BusinessType from './pages/bussinessType/BusinessType';
import Cluster from './pages/cluster/Cluster';
import Chapter from './pages/chapter/Chapter';
import Responsibility from './pages/responsibility/Responsibility';
import User from './pages/user/Userindex';
import UserCreate from './pages/user/Usercreate';
import UserView from './pages/user/UserView';
import BusinessCategory from './pages/bussinessCategory/BusinessCategory';
import BusinessSubCategory from './pages/bussinessSubCategory/BusinessSubCategory';
import BusinessFormation from './pages/bussinessFormation/BusinessFormation';
import BusinessProductservice from './pages/bussinessProductservice/BusinessProductservice';
import EventType from './pages/eventType/EventType';
import Vanue from './pages/eventVanue/Vanueindex';
import VanueCreate from './pages/eventVanue/Vanuecreate';
import EventCreate from './pages/event/Eventcreate';
import EventView from './pages/event/Eventview';
import Event from './pages/event/Eventindex';
import Guest from './pages/guest/Guestindex';
import GuestCreate from './pages/guest/Guestcreate';
import Family from './pages/family/Familyindex';
import FamilyCreate from './pages/family/Familycreate';
import FamilyView from './pages/family/FamilyView';
import Setting from './pages/setting/Setting';
import Banner from './pages/banner/Banner';
import City from './pages/city/City';
import Country from './pages/country/Country';
import State from './pages/state/State';
import Tax from './pages/tax/Tax';
import Fees from './pages/fees/Fees';
import CoreTeam from './pages/coreTeam/CoreTeam';
import ContributionTeam from './pages/contributionTeam/ContributionTeam';
import GrowthPartner from './pages/growthPartner/GrowthPartner';
import GrowthPartnerCluster from './pages/growthPartnerCluster/GrowthPartnerCluster';
import Team from './pages/team/TeamPage';
import ContributionLeval from './pages/contributionLeval/ContributionLeval';
import Core from './pages/core/Core';
import MobileSetting from './pages/mobileSetting/MobileSetting';
import PdfCategory from './pages/pdfCategory/PdfCategory';
import Slider from './pages/slider/Slider';
import SmallBanner from './pages/smallBanner/SmallBanner';
import Pdf from './pages/pdf/Pdf';
import Notification from './pages/notification/Notification';
import Report from './pages/report/Report';
import Ticket from './pages/ticket/Ticket';
import Tag from './pages/tag/Tag';
import PartnerRequest from './pages/partnerRequest/PartnerRequest';
import PricingPlans from './pages/pricingPlans/PricingPlans';
import PlanResponsibility from './pages/planResponsibility/PlanResponsibility';
import FeedbackType from './pages/feedbackType/FeedbackType';
import FeedbackReview from './pages/feedbackReview/FeedbackReview';
import MemberPolicy from './pages/memberPolicy/MemberPolicy';
import PrivacyPolicy from './pages/privacyPolicy/PrivacyPolicy';
import TermCondition from './pages/termCondition/TermCondition';
import BloodgroupRequest from './pages/bloodgroupRequest/BloodgroupRequest';

function App() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/otp" element={<Otp />} />

            <Route element={
                <PrivateRoute>
                    <AppLayout />
                </PrivateRoute>
            }>
                <Route path="dashboard" element={<HomePage />} />
                <Route path="user" element={<User />} />
                <Route path="user/create" element={<UserCreate />} />
                <Route path="user/edit/:id" element={<UserCreate />} />
                <Route path="user/view/:id" element={<UserView />} />
                <Route path="role" element={<RolePage />} />
                <Route path="cluster" element={<Cluster />} />
                <Route path="responsibility" element={<Responsibility />} />
                <Route path="chapter" element={<Chapter />} />
                <Route path="businessType" element={<BusinessType />} />
                <Route path="businessCategory" element={<BusinessCategory />} />
                <Route path="businessSubCategory" element={<BusinessSubCategory />} />
                <Route path="businessProductservice" element={<BusinessProductservice />} />
                <Route path="businessFormation" element={<BusinessFormation />} />
                <Route path="eventType" element={<EventType />} />
                <Route path="vanue" element={<Vanue />} />
                <Route path="vanue/create" element={<VanueCreate />} />
                <Route path="vanue/edit/:id" element={<VanueCreate />} />
                 <Route
          path="event"
          element={
            <PrivateRoute module="Event" action="Read">
              <Event />
            </PrivateRoute>
          }
        />
        <Route
          path="event/create"
          element={
            <PrivateRoute module="Event" action="Create">
              <EventCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="event/edit/:id"
          element={
            <PrivateRoute module="Event" action="Edit">
              <EventCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="event/view/:id"
          element={
            <PrivateRoute module="Event" action="View">
              <EventView />
            </PrivateRoute>
          }
        />
                <Route
          path="guest"
          element={
            <PrivateRoute module="Guest" action="Read">
              <Guest />
            </PrivateRoute>
          }
        />
        <Route
          path="guest/create"
          element={
            <PrivateRoute module="Guest" action="Create">
              <GuestCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="guest/edit/:id"
          element={
            <PrivateRoute module="Guest" action="Edit">
              <GuestCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="guest/view/:id"
          element={
            <PrivateRoute module="Guest" action="View">
              <UserView />
            </PrivateRoute>
          }
        />
                 <Route
          path="family"
          element={
            <PrivateRoute module="Family" action="Read">
              <Family />
            </PrivateRoute>
          }
        />
        <Route
          path="family/create"
          element={
            <PrivateRoute module="Family" action="Create">
              <FamilyCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="family/edit/:id"
          element={
            <PrivateRoute module="Family" action="Edit">
              <FamilyCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="family/view/:id"
          element={
            <PrivateRoute module="Family" action="View">
              <FamilyView />
            </PrivateRoute>
          }
        />
                <Route path="setting" element={<Setting />} />
                <Route path="banner" element={<Banner />} />
                <Route path="city" element={<City />} />
                <Route path="state" element={<State />} />
                <Route path="country" element={<Country />} />
                <Route path="tax" element={<Tax />} />
                <Route path="fees" element={<Fees />} />
                <Route
          path="coreTeam"
          element={
            <PrivateRoute module="CoreTeam" action={["Read", "Create","Edit","Delete"]}>
              <CoreTeam />
            </PrivateRoute>
          }
        />
        <Route
          path="contributionTeam"
          element={
            <PrivateRoute module="ContributionTeam" action={["Read", "Create","Edit","Delete"]}>
              <ContributionTeam />
            </PrivateRoute>
          }
        />
                <Route path="growthPartner" element={<GrowthPartner />} />
                <Route path="growthPartnerCluster" element={<GrowthPartnerCluster />} />
                <Route path="team" element={<Team />} />
                <Route path="contributionLeval" element={<ContributionLeval />} />
                <Route path="core" element={<Core />} />
                <Route path="mobileSetting" element={<MobileSetting />} />
                <Route path="pdfCategory" element={<PdfCategory />} />
                <Route path="slider" element={<Slider />} />
                <Route path="smallBanner" element={<SmallBanner />} />
                <Route path="pdf" element={<Pdf />} />
                <Route path="notification" element={<Notification />} />
                <Route path="report" element={<Report />} />
                <Route path="ticket" element={<Ticket />} />
                <Route path="tag" element={<Tag />} />
                <Route path="partnerRequest" element={<PartnerRequest />} />
                <Route path="pricingPlans" element={<PricingPlans />} />
                <Route path="planResponsibility" element={<PlanResponsibility />} />
                <Route path="feedbackType" element={<FeedbackType />} />
                <Route path="feedbackReview" element={<FeedbackReview />} />
                <Route path="memberPolicy" element={<MemberPolicy />} />
                <Route path="termCondition" element={<TermCondition />} />
                <Route path="privacyPolicy" element={<PrivacyPolicy />} />
                <Route path="bloodgroupRequest" element={<BloodgroupRequest />} />
                
            </Route>
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}

export default App;